import { render, staticRenderFns } from "./ListResponsavelFilialView.vue?vue&type=template&id=44b0f768&"
import script from "./ListResponsavelFilialView.vue?vue&type=script&lang=ts&"
export * from "./ListResponsavelFilialView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports